<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.81 33.52">
    <g id="Calque_2" data-name="Calque 2">
      <g id="ƒŒƒCƒ_1" data-name="ƒŒƒCƒ„[ 1">
        <path
          class="cls-1"
          d="M33.08,20.69a.73.73,0,0,0,.73-.73V13.55a.73.73,0,0,0-.73-.73h-6V7.14a.73.73,0,0,0-.73-.73H21V.73A.73.73,0,0,0,20.26,0H.73A.73.73,0,0,0,0,.73V32.79a.73.73,0,0,0,.73.73H33.08a.73.73,0,0,0,.73-.73V26.38a.73.73,0,0,0-.73-.73h-6v-5Zm-.73-1.45H21v-5H32.35Zm-24.19,0v-5H19.53v5Zm4.66,6.41H1.46v-5H12.82Zm0-17.78v5H1.46V7.87ZM6.7,19.24H1.46v-5H6.7Zm19-6.42H14.28V7.87H25.65ZM19.53,6.41H8.16V1.46H19.53ZM1.46,1.46H6.7v5H1.46Zm0,25.65H6.7v5H1.46Zm6.7,0H19.53v5H8.16Zm24.19,5H21v-5H32.35Zm-6.7-6.41H14.28v-5H25.65Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconComponent',
};
</script>

<style scoped>
.cls-1 {
  fill: #162b46;
}
</style>
